
import { uuid } from "./utils/uuid"
import {addJwt, getJwt, cleanLoginStatus} from "./utils/loginUtils"
import axios from 'axios';
import setting from "../config/setting";

layui.use("layer");
let OSS = require('ali-oss');
let cache = {
  location: null,
  //id、账号等信息
  accountInfo: null,
  //社交信息、头像、昵称、签名
  info: null,
  vue: null,
  jwt: null,
};
let emptyFunction = function () {}
export default {
  install(vue) {
    cache.vue = vue;
  },
  //public-im-space bucket上传
  ossUpload(path, file, uploadOption, successEvent, progressEvent, errorEvent, completeEvent) {
    progressEvent = progressEvent ? progressEvent : emptyFunction;
    errorEvent = errorEvent ? errorEvent : emptyFunction;
    completeEvent = completeEvent ? completeEvent : emptyFunction;
    //开始上传设置进度为10
    progressEvent(10);
    new OSS(setting.public).put(path, file, uploadOption).then(result => {
      // console.log(result, "上传成功返回参数");
      progressEvent(100);
      successEvent(result);
      completeEvent();
    }).catch(err => {
      console.log(err);
      errorEvent(err);
      completeEvent();
    });
  },
  //url:请求地址，method:请求方式,needToken:是否需要登陆身份，successEvent:请求200回调，completeEvent:代码执行完成回调，errorEvent: 请求非200回调
  executeHttp(url, params, method, needToken, successEvent, completeEvent, errorEvent) {
    successEvent = successEvent ? successEvent : emptyFunction;
    completeEvent = completeEvent ? completeEvent : emptyFunction;
    let headers = {};
    if (needToken) {
      //拿到用户jwt
      if (!cache.jwt) {
        cache.jwt = getJwt();
      }
      headers.authorization = cache.jwt;
    }
    url = "/api" + (url.indexOf("/") < 0 ? "/" : "") + url;
    // let environment = process.env.NODE_ENV;
    // if (environment === 'development') {
    //   url = "/api" + url;
    // }
    // if (environment === 'production') {
    //   url = setting.domain + "/api" + url;
    // }
    let config = {
      url: url,
      method: method,
      headers: headers
    };
    //get请求要改变参数名
    if (method === "GET" || method === "get") {
      config.params = params;
    } else {
      // config.headers['Content-Type'] = "application/json;charset=UTF-8"
      config.data = params ? params : {};
    }
    axios(config).then(({data, headers}) => {
      if (data.code >= 200 && data.code <= 299) {
        successEvent(data.data);
      } else if (data.code === 401) {
        this.toLogin();
      } else {
        errorEvent ? errorEvent(data.message) : this.showMessage(data.message, {icon: 5});
      }
      //尝试取出Authorization响应头，若存在则存入localStorage
      if (headers.authorization) {
        cache.jwt = headers.authorization;
        addJwt(headers.authorization);
      }
      completeEvent();
    }).catch((e) => {
      let {response, request} = e;
      let msg;
      if (response) {
        console.log(response);
        msg = response.data.message ? response.data.message : response.data;
      } else if (request) {
        //网络请求失败
        console.log(request);
        msg = "网络异常";
      } else {
        console.log(e);
        msg = "代码运行时异常";
      }
      errorEvent ? errorEvent(msg) : this.showMessage(msg);
      completeEvent();
    });
  },
  logout() {
    cleanLoginStatus();
    this.toLogin();
  },
  toLogin() {
    cache.vue.$router.push("/login", () => {
      location.reload();
    });
  },
  showNotify(title = "提示", msg, type = 'info', time = 4500) {
    cache.vue.$notify({
      title: title,
      message: msg,
      type: type,
      duration: time,
    });
  },
  showMessage(msg, option) {
    layer.msg(msg, option);
  },
  showAlert(msg, icon, callBack) {
    layer.alert(msg, {icon: icon, scrollbar: false, closeBtn: 0}, (index) => {
      if (callBack) callBack();
      layer.close(index);
    });
  },
  showConfirm(msg, option, callBack, cancelCallback) {
    layer.confirm(msg, option, (index) => {
      callBack();
      layer.close(index);
    }, cancelCallback);
  },
  login(url, params, successEvent, completeEvent, errorEvent) {
    let successEventWrapper = (data) => {
      cache.accountInfo = data;
      this.goSpace(data.id, successEvent)
    };
    this.executeHttp(
      url,
      params,
      "POST",
      false,
      successEventWrapper,
      completeEvent,
      errorEvent)
  },
  //获取当前位置
  getLocation(successEvent, errorEvent, userCache) {
    let location = cache.location;
    if (location && userCache) {
      return successEvent(location);
    }
    let callback = function () {
      new Promise((resolve, reject) => {
        new BMap.Geolocation().getCurrentPosition(function (r) {
          if ((0 !== this.getStatus())) {
            console.log("获取位置失败StatusCode = " + this.getStatus());
            return reject("获取位置失败");
          }
          new BMap.Geocoder().getLocation(r.point, function (rs) {
            if (!rs) {
              return reject("获取位置失败");
            }
            resolve({
              longitude: rs.point.lng,
              latitude: rs.point.lat,
              province: rs.addressComponents.province,
              city: rs.addressComponents.city,
              district: rs.addressComponents.district,
              street: rs.addressComponents.street
            });
          });
        }, {enableHighAccuracy: true, maximumAge: !userCache ? 0 : 600000, timeout: 20000});
      }).then((data) => {
        cache.location = data;
        successEvent(data);
        window.baiduMapJSInitCallback = null;
      }).catch((msg) => {
        errorEvent ? errorEvent(msg) : "";
        window.baiduMapJSInitCallback = null;
      });
    };
    if (window.BMap && window.BMap.Geolocation && window.BMap.Geocoder) {
      callback();
    } else {
      console.log("初始化加载百度地图...");
      window.baiduMapJSInitCallback = callback;
      let script = document.createElement("script");
      script.src = "https://api.map.baidu.com/api?v=2.0&ak=" + setting.baiduMapAK + "&callback=baiduMapJSInitCallback";
      script.async = "async";
      script.type = "text/javascript";
      script.onload = function () {
        console.log("百度地图加载成功");
      };
      document.body.appendChild(script);
    }
  },
  cleanLoginStatus() {
    cleanLoginStatus()
  },
  //获取账号信息，id、手机号等
  getAccountInfo(callback) {
    if (cache.accountInfo) {
      callback(cache.accountInfo)
    } else {
      this.executeHttp("/USER/v1/users/mine/info", null, "GET", true, (data) => {
        callback(data);
        cache.accountInfo = data;
      }, null, () => {
        callback({});
      })
    }
  },
  //获取我的社交信息，头像、昵称、签名等
  getInfo(callback) {
    if (cache.info) {
      callback(cache.info)
    } else {
      this.getAccountInfo(({id}) => {
        this.executeHttp("/USER/v1/users/" + id, null, "GET", true, (data) => {
          callback(data);
          cache.info = data;
        })
      });
    }
  },
  //去我的主页
  goMySpace() {
    this.getAccountInfo(({id}) => {
      this.goSpace(id);
    });
  },
  goSpace(id, completeCallback) {
    if (!completeCallback)
      completeCallback = emptyFunction()
    cache.vue.$router.push("/spaces/" + id, completeCallback);
  },
};



// WEBPACK FOOTER //
// ./src/js/im-detail.js